export default __webpack_public_path__ + "static/angela-dittmar-5e069d5f3beacb2d0534af38c43184cc.jpg";